import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SimpleReactValidator from 'simple-react-validator';

const ConsultingFrom = () => {
	const [forms, setForms] = useState({
		firstname: '',
		lastname: '',
		email: '',
		subject: '',
		phone: '',
		message: '',
	});
	const [validator] = useState(
		new SimpleReactValidator({
			className: 'errorMessage',
			locale: 'fr',
			messages: {
				required: `Le champ ':attribute' est obligatoire.`,
				email: "L':attribute n'est pas valide.",
				min: 'Ce champ doit contenir au moins :min caractères.',
				max: 'Ce champ ne doit pas dépasser :max caractères.',
				alpha_space: 'Ce champ ne peut contenir que des lettres.',
				numeric: 'Ce champ doit être un nombre.',
				phone: 'Le numéro de téléphone doit être au format international - Min 10 chiffres (exemple : +3271234567).)',
				// ... ajoute d’autres messages personnalisés ici
			},
		})
	);

	const [statusMessage, setStatusMessage] = useState({ type: '', text: '' });

	const changeHandler = e => {
		setForms({ ...forms, [e.target.name]: e.target.value });
		if (validator.allValid()) {
			validator.hideMessages();
		} else {
			validator.showMessages();
		}
	};

	const submitHandler = async e => {
		e.preventDefault();

		if (validator.allValid()) {
			try {
				const response = await axios.post(
					'https://api.brevo.com/v3/smtp/email',
					{
						sender: { name: 'Website contact form', email: 'brevo.gavalex@one-o-one.be' },
						to: [
							{ name: 'GAVA-Lex', email: 'secretariat@gava-lex.be' },
							// { name: 'Michael Arnhem', email: 'info@one-o-one.be' },
							// { name: 'Michael Arnhem', email: 'marnhem@gmail.com' },
						],
						subject: forms.subject,
						htmlContent: `
						<p><strong>Prénom : </strong>${forms.firstname}</p>
						<p><strong>Nom : </strong>${forms.lastname}</p>
						<p><strong>Email : </strong>${forms.email}</p>
						<p><strong>Téléphone : </strong>${forms.phone}</p>	
						<p><strong>Sujet : </strong>${forms.subject}</p>	
						<p><strong>Message : </strong><br />${forms.message}</p>
						`,
					},
					{
						headers: {
							'api-key':
								'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',
							'Content-Type': 'application/json',
						},
					}
				);

				setStatusMessage({ type: 'success', text: 'Merci ! Votre email a été envoyé.' });
				console.log('Email sent successfully:', response.data);

				validator.hideMessages();
				setForms({ firstname: '', lastname: '', email: '', subject: '', phone: '', message: '' });
			} catch (error) {
				setStatusMessage({ type: 'error', text: "Erreur d'envoi de l'email. Veuillez essayer à nouveau." });
				console.error('Error sending email:', error);
			}
		} else {
			validator.showMessages();
		}
	};

	return (
		<form
			method='post'
			className='contact-validation-active mx-[-15px] overflow-hidden contact-form'
			id='contact-form-main'
			onSubmit={e => submitHandler(e)}
		>
			<div style={{ display: 'flow-root' }}>
				<div className='w-[calc(50%-30px)] float-left mx-[15px] mb-[25px] col:float-none col:w-[calc(100%-25px)]'>
					<input
						className='form-control w-full font-normal bg-[rgba(192,181,150,.2)] h-[50px] border border-[rgba(192,181,150,.5)] text-[#c0b596] transition-all pl-[15px] focus:outline-0 focus:shadow-none focus:border-transparent focus:bg-white '
						value={forms.firstname}
						type='text'
						name='firstname'
						onBlur={e => changeHandler(e)}
						onChange={e => changeHandler(e)}
						placeholder='Votre prénom'
					/>
					{validator.message('Prénom', forms.firstname, 'required|string')}
				</div>
				<div className='w-[calc(50%-30px)] float-left mx-[15px] mb-[25px] col:float-none col:w-[calc(100%-25px)]'>
					<input
						className='form-control w-full font-normal bg-[rgba(60,52,31,0.2)] h-[50px] border border-[rgba(192,181,150,.5)] text-[#c0b596] transition-all pl-[15px] focus:outline-0 focus:shadow-none focus:border-transparent focus:bg-white '
						value={forms.lastname}
						type='text'
						name='lastname'
						onBlur={e => changeHandler(e)}
						onChange={e => changeHandler(e)}
						placeholder='Votre nom de famille'
					/>
					{validator.message('Nom de famille', forms.lastname, 'required|string')}
				</div>
			</div>
			<div style={{ display: 'flow-root' }}>
				<div className='w-[calc(50%-30px)] float-left mx-[15px] mb-[25px] col:float-none col:w-[calc(100%-25px)]'>
					<input
						className='form-control  w-full font-normal bg-[rgba(192,181,150,.2)] h-[50px] border border-[rgba(192,181,150,.5)] text-[#c0b596] transition-all pl-[15px] focus:outline-0 focus:shadow-none focus:border-transparent focus:bg-white'
						value={forms.email}
						type='email'
						name='email'
						onBlur={e => changeHandler(e)}
						onChange={e => changeHandler(e)}
						placeholder='Votre e-mail'
					/>
					{validator.message('adresse email', forms.email, 'required|email')}
				</div>
				<div className='w-[calc(50%-30px)] float-left mx-[15px] mb-[25px] col:float-none col:w-[calc(100%-25px)]'>
					<input
						className='form-control  w-full font-normal bg-[rgba(192,181,150,.2)] h-[50px] border border-[rgba(192,181,150,.5)] text-[#c0b596] transition-all pl-[15px] focus:outline-0 focus:shadow-none focus:border-transparent focus:bg-white'
						value={forms.phone}
						type='phone'
						name='phone'
						onBlur={e => changeHandler(e)}
						onChange={e => changeHandler(e)}
						placeholder='Votre numéro de téléphone'
					/>
					{validator.message('téléphone', forms.phone, 'required|phone')}
				</div>
			</div>
			<div className='w-[calc(100%-30px)] float-left mx-[15px] mb-[25px] col:float-none col:w-[calc(100%-25px)]'>
				<input
					className='form-control w-full font-normal bg-[rgba(192,181,150,.2)] h-[50px] border border-[rgba(192,181,150,.5)] text-[#c0b596] transition-all pl-[15px] focus:outline-0 focus:shadow-none focus:border-transparent focus:bg-white '
					value={forms.subject}
					type='text'
					name='subject'
					onBlur={e => changeHandler(e)}
					onChange={e => changeHandler(e)}
					placeholder='Sujet'
				/>
				{validator.message('sujet', forms.subject, 'required')}
			</div>
			<div className='w-[calc-(100%-25px)] mb-[25px] mx-[15px]'>
				<textarea
					className='form-control  w-full bg-[rgba(192,181,150,.2)] h-[150px] border border-[rgba(192,181,150,.5)]  text-[#c0b596] transition-all pt-[15px] pl-[15px] focus:outline-0 focus:shadow-none focus:border-transparent focus:bg-white'
					onBlur={e => changeHandler(e)}
					onChange={e => changeHandler(e)}
					value={forms.message}
					type='text'
					name='message'
					placeholder='Message'
				></textarea>
				{validator.message('message', forms.message, 'required')}
			</div>
			<div className='text-left w-full mb-[10px] ml-[16px] flex content-center'>
				<button
					type='submit'
					className='bg-[#c0b596] text-[16px] font-semibold text-white px-[38px] py-[10px]  capitalize inline-block mt-[6px] transition ease-in-out duration-300 hover:bg-[#d4c291]
col:mb-[5px] col:mt-[15px] col:text-[15px] col:px-[18px] col:py-[8px] cursor-pointer m'
				>
					Envoyer
				</button>

				{statusMessage.text && (
					<div
						className={`message self-center ml-[20px] ${statusMessage.type === 'success' ? 'text-green-600' : 'text-red-600'}`}
					>
						{statusMessage.text}
					</div>
				)}

				<div id='loader'>
					<i className='ti-reload'></i>
				</div>
			</div>
		</form>
	);
};

export default ConsultingFrom;
